module.exports = __webpack_public_path__ + "static/img/20005D_1_2_C_20210302_fit.cef1436.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/20005D_1_2_C_20210302_fit.png
// module id = w4up
// module chunks = 0